import React, {Component} from "react";
import { Row, Col, Button, FormGroup, Label, Input } from "reactstrap";
import { inject, observer } from "mobx-react";
import FormInput from "../../../../comum/components/FormInput";
import Card from "../../../../comum/components/Card";
import FormSelect from "../../../../comum/components/FormSelect";
import { IconeDelete } from "../../../../comum/components/Icones";
import RetiradaDepotStore from "../stores/RetiradaDepotStore";
import RadiobuttonGroup from '../../../../comum/components/RadiobuttonGroup';

@inject("store")
@observer
export class RetiradaDepotForm extends Component {
    constructor(props) {
        super(props);
        this.parametrosStore = this.props.store.parametrosStore;
        
        this.agendamentoController = this.props.agendamentoController;
        this.controller = new RetiradaDepotStore();
    };

    componentDidMount() {       
        if (!this.agendamentoController.isEditar){
            this.agendamentoController.adicionarRetirada();
        } else {
            if(this.agendamentoController.dadosAgendamento.listaBookings
                && this.agendamentoController.dadosAgendamento.listaBookings.length > 0
                && this.agendamentoController.dadosAgendamento.listaBookings[0].containers){

                this.agendamentoController.dadosAgendamento.listaBookings[0].containers.map((cntr, x) => {
                    this.controller.carregarDadosBooking(cntr.NumBooking ? cntr.NumBooking : "", x, this.agendamentoController.dadosAgendamento, false)
                    this.controller.carregarTiposCntrPorBooking(cntr.NumBooking ? cntr.NumBooking : "", x, this.agendamentoController.dadosAgendamento, false)})
            }
        }
    };

    botaoAdicionar(titulo) {
        return <Button onClick={ this.handleAdicionarClick } className="btn-com-bordas-primary">{titulo}</Button>;
    };

    handleAdicionarClick = () => {
        this.agendamentoController.adicionarRetiradaDepot(); 
        this.controller.adicionaNovoItemRetirada();
    }

    handleRemoverClick = (index) => {
        this.agendamentoController.removerRetiradaDepot(index);
        this.controller.removerItemRetirada(index);
    }

    campoQuantidade(dado, md, index) {
        return this.agendamentoController.atualizaRetiradas && <FormInput   titulo="Quantidade" xs={12} sm={12} md={md} type="number"
                            objeto={ this.agendamentoController.dadosAgendamento }
                            dado={ dado }                            
                            onChange={ (event) => {
                                if(event.target.value > this.controller.saldo[index]) {
                                    this.agendamentoController.listaMensagens = ["Quantidade maior do que permitida. O booking possui um saldo " + this.controller.saldo[index]];
                                    event.target.value = "";
                                }else {
                                    this.agendamentoController.setDadosAgendamento(dado, event) ;
                                }                                
                            }} 
                />;
    };

    campoVentilacao(dado, md, index) {
        return this.agendamentoController.atualizaRetiradas && <FormInput   titulo="Ventilação" xs={12} sm={12} md={md} type="number"
                            objeto={ this.agendamentoController.dadosAgendamento }
                            dado={ dado }
                            //obrigatorio={ this.controller.isReefer[index] }
                            //inicialmente o observable isReefer não é undefined, nem null, nem true/false, por isso fiz assim
                            //bloqueado={ this.controller.isReefer[index] === true ? false : true }
                            onChange={ (event) => this.agendamentoController.setDadosAgendamento(dado, event) } 
                />;
    };

    campoUmidade(dado, md, index) {
        return this.agendamentoController.atualizaRetiradas && <FormInput   titulo="Umidade" xs={12} sm={12} md={md} type="number"
                            objeto={ this.agendamentoController.dadosAgendamento }
                            dado={ dado }
                            //obrigatorio={ this.controller.isReefer[index] }
                            //inicialmente o observable isReefer não é undefined, nem null, nem true/false, por isso fiz assim
                            //bloqueado={ this.controller.isReefer[index] === true ? false : true }
                            onChange={ (event) => this.agendamentoController.setDadosAgendamento(dado, event) } 
                />;
    };

    campoTemperatura(dado, md, index) {
        return this.agendamentoController.atualizaRetiradas && <FormInput   titulo="Temperatura" xs={12} sm={12} md={md} type="number"
                            objeto={ this.agendamentoController.dadosAgendamento }
                            dado={ dado }
                            //obrigatorio={ this.controller.isReefer[index] }
                            //inicialmente o observable isReefer não é undefined, nem null, nem true/false, por isso fiz assim
                            //bloqueado={ this.controller.isReefer[index] === true ? false : true } 
                            onChange={ (event) => this.agendamentoController.setDadosAgendamento(dado, event) } 
                />;
    };

    campoGensetAcoplado(dado, md, index) {
        return this.agendamentoController.atualizaRetiradas && <RadiobuttonGroup xs={12} sm={12} md={md}
                    titulo="Genset Acoplado?"
                    name={"GensetAcoplado" + index}
                    onClick={ (event) => this.agendamentoController.setDadosAgendamento(dado, event) } 
                    itens={[
                        { id: "Nao"+index, value: "0", label: "Não ", checked: _.get(this.agendamentoController.dadosAgendamento, `listaBookings[0].containers[${index}].FlgGensetAcoplado`) !== "1"},
                        { id: "Sim"+index, value: "1", label: "Sim ", checked: _.get(this.agendamentoController.dadosAgendamento, `listaBookings[0].containers[${index}].FlgGensetAcoplado`) === "1"}
                    ]}
                />
    }

    campoBooking(dado, md, index) {
        return this.agendamentoController.atualizaRetiradas && <FormInput  sm={12} xs={12} md={md} titulo="Booking"
                            bloqueado={ false }
                            objeto={ this.agendamentoController.dadosAgendamento }
                            dado={ dado }
                            onChange={ (event) => this.handleChangeBooking(dado, event, index, this.agendamentoController.dadosAgendamento) }  
                />;
    };

    campoArmador(dado, md, index) {
        return this.agendamentoController.atualizaRetiradas && <FormInput  xs={12} sm={12} md={md} titulo="Armador"
                            bloqueado={ true }
                            value={ this.controller.armador[index] ? this.controller.armador[index].ApelidoArmador : null }
                            objeto={ this.agendamentoController.dadosAgendamento }
                            dado={ dado }
                            onChange={ (event) => this.agendamentoController.setDadosAgendamento(dado, event) } 
                />;
    };

    campoOperacao(dado, md, index) {
        return this.agendamentoController.atualizaRetiradas && <FormInput  xs={12} sm={12} md={md} titulo="Operação"
                            bloqueado={ true }
                            value={ this.controller.operacao[index] ? this.controller.operacao[index].NavioViagem : null }
                            objeto={ this.agendamentoController.dadosAgendamento }
                            dado={ dado }
                            onChange={ (event) => this.agendamentoController.setDadosAgendamento(dado, event) } 
                />;
    };

    campoPod(md, index) {
        return this.agendamentoController.atualizaRetiradas && <FormInput  xs={12} sm={12} md={md} titulo="Porto de Descarga"
                            bloqueado={ true }
                            value={ this.controller.pod[index] ? this.controller.pod[index].DescPortoOrig : null }
                            objeto={ this.agendamentoController.dadosAgendamento }
                />;
    };

    campoDestino(md, index) {
        return this.agendamentoController.atualizaRetiradas && <FormInput  xs={12} sm={12} md={md} titulo="Destino Final"
                            bloqueado={ true }
                            value={ this.controller.destino[index] ? this.controller.destino[index].DescPortoDest : null }
                            objeto={ this.agendamentoController.dadosAgendamento }
                />;
    };

    campoTipoCntr(dado, md, index) {
        return this.agendamentoController.atualizaRetiradas && <FormSelect  xs={12} sm={12} md={md} titulo="Tipo"
                            bloqueado={ false }
                            itens={ this.controller.tiposCntr[index] }
                            objeto={ this.agendamentoController.dadosAgendamento }
                            dado={ dado }
                            itensValor="CodTipoCntr" itensLabel="CodTipoCntr"
                            onChange={ (event) => this.handleChangeTipoCntr(dado, event, index) } 
                />;
    };

    handleChangeBooking = (dado, event, index, dadosAgendamento) => {
        this.controller.carregarDadosBooking(event && event.target ? event.target.value : "", index, dadosAgendamento, this.agendamentoController);
        this.controller.carregarTiposCntrPorBooking(event && event.target ? event.target.value : "", index, dadosAgendamento);
        this.agendamentoController.setDadosAgendamento(dado, event);
        
        this.agendamentoController.atualizaRetiradas = false;
        setTimeout(function () {
            this.agendamentoController.atualizaRetiradas = true;
        }.bind(this), 1)
    };

    handleChangeTipoCntr = (dado, event, index) => {
        console.log("Event - ", event);
        let item = this.controller.tiposCntr[index].filter(item => item.CodTipoCntr === event.value);
    
        if("S" !== item[0].FlgRefrigCntr){
            this.agendamentoController.listaMensagens = ["Agendamento somente permitido para Reefers. Por favor, selecione um Tipo compatível."];
        } else {
            //this.controller.qtdDisponivel[index] = item[0].Quantidade;
            //this.controller.isReefer[index] = "S" === item[0].FlgRefrigCntr;
            //this.controller.carregarDadosTipoCntr(item[0].BookingCntrId, index);
            this.agendamentoController.setDadosAgendamento(dado, event);
        }        
        
        this.agendamentoController.atualizaRetiradas = false;
        setTimeout(function () {
            this.agendamentoController.atualizaRetiradas = true;
        }.bind(this), 1)
    };
    
    campoQuantidadeDisponivel(md, index) {
        return <Col xs={12} sm={12} md={md}>
            <FormGroup>
                <Label>Qtd Disponível</Label>
                <Input defaultValue={ this.controller.qtdDisponivel[index] }
                    disabled = {true} />
            </FormGroup>
        </Col>;
    };

    labelDadosTemperaturaBooking(md, index){
        return this.agendamentoController.atualizaRetiradas && this.controller.dadosTipoCntrBooking[index] &&
            <Col xs={12} sm={12} md={md}>
                <div classlist="alert alert-info" role="alert">
                    {this.controller.dadosTipoCntrBooking[index]}
                </div>
            </Col>
    }

    cardVazioImp(titulo) {
       
            return <div>
                <Row>
                    <Col>
                        <h2>{ titulo }</h2>
                    </Col>
                    { !this.agendamentoController.isEditar && this.botaoAdicionar("Novo") }                    
                </Row>
                <Row>
                    { 
                     this.agendamentoController.dadosAgendamento.listaBookings
                        && this.agendamentoController.dadosAgendamento.listaBookings.length > 0
                        && this.agendamentoController.dadosAgendamento.listaBookings[0].containers
                        && this.agendamentoController.dadosAgendamento.listaBookings[0].containers.map((cntr, x) =>
                            <Col className="area-form card-form" xl={12} key={x}>
                                <Card>
                                    <Row>
                                        { this.campoBooking(`listaBookings[0].containers[${x}].NumBooking`, 4, x) }
                                        { this.campoArmador(`listaBookings[0].containers[${x}].ArmIdDepot`, 4, x) }
                                        { this.campoOperacao(`listaBookings[0].containers[${x}].VesselvisitId`, 4, x) }
                                        { this.campoTipoCntr(`listaBookings[0].containers[${x}].CdTipoCntr`, 4, x) }
                                        { this.campoGensetAcoplado(`listaBookings[0].containers[${x}].FlgGensetAcoplado`, 3, x)}
                                        { 
                                        //this.campoQuantidadeDisponivel(2, x) 
                                        }
                                        { this.campoPod(3, x) }
                                        { this.campoDestino( 3, x) }
                                        { this.campoQuantidade(`listaBookings[0].containers[${x}].QtdRetirada`, 3, x) }
                                        { this.campoVentilacao(`listaBookings[0].containers[${x}].ValVent`, 3, x) }
                                        { this.campoUmidade(`listaBookings[0].containers[${x}].ValUmid`, 3, x) }
                                        { this.campoTemperatura(`listaBookings[0].containers[${x}].ValTmpIdea`, 3, x) }
                                        <Col xs={12} sm={12} md={12}>
                                            <span>
                                                Caso o Armador não tenha informado um valor de Ventilação, Umidade ou Temperatura, deixe o campo em branco.
                                                <br/>Números negativos são aceitos, bem como frações. Ex: -18, 3.5, 0.
                                                <br/>
                                            </span>
                                        </Col>
                                        { this.labelDadosTemperaturaBooking(12, x)}
                                    </Row>
                                </Card>
                                { !this.agendamentoController.isEditar
                                    && <IconeDelete className="icone-delete-borda" tamanho="3x" onClick={ () =>  this.handleRemoverClick(x) } /> }
                            </Col>
                    )}
                </Row>                
            </div>
    };

    

    formDepot() {
        console.log(this.props.tipoAgenda);
        switch (this.props.tipoAgenda) {
            case "DRE":
                return this.cardVazioImp("Depot - Retirada Exportação Reefer");
            default:
                break;
        }
    };

    render() {
        return (
            <div>
                { (this.agendamentoController.terminal === "SSA") && this.formDepot() }
            </div>
        );
    };
}



// WEBPACK FOOTER //
// ./src/modules/agendamento/containers-cadastrar/retirada-containers-depot/components/RetiradaDepotForm.js